import { render } from "./ApplicantForm.vue?vue&type=template&id=60fd6bb8"
import script from "./ApplicantForm.vue?vue&type=script&lang=js"
export * from "./ApplicantForm.vue?vue&type=script&lang=js"

import exportComponent from "/home/time/IdeaProjects/mektep-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__